export default "__VITE_ASSET__6d82bc7a__"